<template>
    <div class="page" id="PAGE-SWF" >
        <!-- 幻灯片时长 -->
        <div class="total-time">{{formatDuration(current_time)+'/'+formatDuration(total_time)}}</div>
        <!-- 操作按钮 -->
        <div class="ope-list">
            <div @click="handleAdd()" class="icon-template_add" title="添加"></div>
            <div @click="hanldePause()" class="icon-template_copy" title="复制"></div>
            <div @click="hanldeSave()" style="font-size:26px;" class="icon-home_template_save" title="另存为模版"></div>
            <div @click="handleDel()" class="icon-template_delete" title="删除"></div>
        </div>
        <!-- 列表 -->
        <div class="page-list">
            <!--<div class="page-item" v-for="item, index in page_list">-->
                <!--<div :class="{active: item.active}" @click="handlePageChange(index)" >-->
                    <!--<span v-if="item.cover == ''">{{index + 1 }}</span>-->
                    <!--<img v-if="item.cover != ''" :src="item.cover" />-->
                <!--</div>-->
            <!--</div>-->
            <div id="bottom">
                <draggable v-model="page_list" @end="onDragEnd">
                    <transition-group>
                        <div v-for="(item,index) in page_list" 
                            :key="item.id || 'page_' + index" 
                            @click="handlePageChange(index)" 
                            class="page-item">
                            <div :class="{active: item.active}">
                                <span v-if="item.cover == ''">{{index + 1}}</span>
                                <p v-if="item.cover != ''" style="position:absolute;right:0;top:0;background:rgba(0,0,0,0.4);width:24px;height:15px;line-height:15px;font-size:10px;text-align:center;color:#fff;">{{index + 1}}</p>
                                <img v-if="item.cover != ''" :src="item.cover" />
                            </div>
                        </div>
                    </transition-group>
                </draggable>
            </div>
            <div class="box"></div>
        </div>
        <div class="play-btn">
            <el-button  class="start" type="text" @click="handlePlay()" v-if="play_status">
                <span ><!--class="icon-template_play icon"-->
                    <span class="path1"></span><span class="path2"></span>
                </span>
            </el-button>
            <el-button  class="stop" type="text" @click="handlePause()" v-if="!play_status">
                <span><!--class="icon-template_stop icon"-->
                    <span class="path1"></span><span class="path2"></span><span class="path3"></span>
                </span>
            </el-button>
        </div>
    </div>
</template>
<script>
    // 通讯协议
    import Protocol from '@/common/scripts/protocol.js'
    // 工具类
    import EUY from '@/common/scripts/euy.js'

    import draggable from 'vuedraggable';

    export default {

        name: 'page',
        components:
        {
            draggable
        },
        data ()
        {
            return {
                // -------------------------------------------------- [ FLASH ] --------------------------------------------------
                platform: this.$route.query.platform,
                // 总时长
                total_time: 0,
                // 当前播放时长
                current_time: 0,
                // 模板详情列表
                page_list: [],
                // 模板初始加载
                page_item_init: 0,
                // 播放状态
                play_status: true,
                select_index: 0,
                can_play: false,
                _pageIdCounter: 0, // 用于生成唯一ID
            }
        },

        methods:
        {
            onDragEnd: function onDragEnd(evt) {
                console.log('dddddd' + ' 移动前的位置 ' + evt.oldIndex + ' 移动后的位置 ' + evt.newIndex + '====>');
                let  platform = this.$route.query.platform
                let page_scene_8_10 = {
                    packageId: 0,
                    senderId: PAGE,
                    senderName: PAGE_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 8,
                    messageId: 10,
                    protoBytesType: 'com.proto.page.MMovePage',
                    protoBytes: Protocol.serializeBinary(new proto.com.proto.page.MMovePage(), {
                        setFrom: evt.oldIndex,
                        setTo: evt.newIndex
                    })
                }
                // 发送消息
                Protocol.sender(platform, page_scene_8_10)
            },
            // 选择动画
            handlePageChange (index) {
                console.log("index ==>" + index)
                this.play_status = false
                for(var i=0;i<this.page_list.length;i++){
                    this.page_list[i].active = false
                }
                this.page_list[index].active = true
                this.page_item_init = index
                // 选择页
                let  platform = this.$route.query.platform
                let MInt32  = new proto.com.proto.s.MInt32()
                MInt32.setValue(this.page_item_init)
                let protoBytes = MInt32.serializeBinary()
                let protoBytesArray = Array.from(protoBytes)
                let page_scene_8_9 = {
                    packageId: 0,
                    senderId: PAGE,
                    senderName: PAGE_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 8,
                    messageId: 9,
                    protoBytesType: 'proto.com.proto.s.MInt32',
                    protoBytes: protoBytesArray
                }
                // 发送消息
                Protocol.sender(platform, page_scene_8_9)
            },

            // 添加
            handleAdd ()
            {
                console.log('tianjia=====>' + this.page_item_init)
                const newPage = {
                    id: 'page_' + (this._pageIdCounter++),
                    cover: '',
                    active: false,
                    // ... 其他属性
                };
                this.page_list.push(newPage);
                let  platform = this.$route.query.platform
                let MInt32  = new proto.com.proto.s.MInt32()
                MInt32.setValue(this.page_item_init + 1)
                let protoBytes = MInt32.serializeBinary()
                let protoBytesArray = Array.from(protoBytes)
                let page_scene_8_6 = {
                    packageId: 0,
                    senderId: PAGE,
                    senderName: PAGE_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 8,
                    messageId: 6,
                    protoBytesType: 'proto.com.proto.s.MInt32',
                    protoBytes: protoBytesArray
                }
                // 发送消息
                Protocol.sender(platform, page_scene_8_6)
            },

            // 复制
            hanldePause ()
            {
                console.log('fuzhi====>' + this.page_item_init)
                let  platform = this.$route.query.platform
                let MInt32  = new proto.com.proto.s.MInt32()
                MInt32.setValue(this.page_item_init)
                let protoBytes = MInt32.serializeBinary()
                let protoBytesArray = Array.from(protoBytes)
                let page_scene_8_5 = {
                    packageId: 0,
                    senderId: PAGE,
                    senderName: PAGE_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 8,
                    messageId: 5,
                    protoBytesType: 'proto.com.proto.s.MInt32',
                    protoBytes: protoBytesArray
                }
                // 发送消息
                Protocol.sender(platform, page_scene_8_5)
            },

            // 另存为模版
            hanldeSave(){
                let  platform = this.$route.query.platform
                    
                    let page_scene_8_13 = {
                        packageId: 0,
                        senderId: PAGE,
                        senderName: PAGE_NAME,
                        receiverId: SCENE,
                        receiverName: SCENE_NAME,
                        timeFlag: new Date().getTime(),
                        sessionId: 8,
                        messageId: 13,
                        protoBytesType: '',
                        protoBytes: []
                    }
                    // 发送消息
                    Protocol.sender(platform, page_scene_8_13)
            },

            // 删除
            handleDel ()
            {
                if(this.page_list.length <= 1){
                    alert('动画数量不能少于1个')
                }else{
                    let  platform = this.$route.query.platform
                    let MInt32  = new proto.com.proto.s.MInt32()
                    MInt32.setValue(this.page_item_init)
                    let protoBytes = MInt32.serializeBinary()
                    let protoBytesArray = Array.from(protoBytes)
                    // 删除页
                    let page_scene_8_4 = {
                        packageId: 0,
                        senderId: PAGE,
                        senderName: PAGE_NAME,
                        receiverId: SCENE,
                        receiverName: SCENE_NAME,
                        timeFlag: new Date().getTime(),
                        sessionId: 8,
                        messageId: 4,
                        protoBytesType: 'proto.com.proto.s.MInt32',
                        protoBytes: protoBytesArray
                    }
                    // 发送消息
                    Protocol.sender(platform, page_scene_8_4)
                }
            },

            // 播放
            handlePlay ()
            {
                this.play_status = false
                let  platform = this.$route.query.platform
                let MInt32  = new proto.com.proto.s.MInt32()
                MInt32.setValue(0)
                let protoBytes = MInt32.serializeBinary()
                let protoBytesArray = Array.from(protoBytes)
                let page_scene_8_7 = {
                    packageId: 0,
                    senderId: PAGE,
                    senderName: PAGE_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 8,
                    messageId: 7,
                    protoBytesType: 'proto.com.proto.s.MInt32',
                    protoBytes: protoBytesArray
                }
                // 发送消息
                Protocol.sender(platform, page_scene_8_7)
            },

            formatDuration (duration)
            {
                // parseInt(duration)
                return moment(Math.round(duration) * 1000).format('mm:ss')
            },

            // 暂停按钮
            handlePause ()
            {
                this.play_status = true
                let  platform = this.$route.query.platform
                let MInt32  = new proto.com.proto.s.MInt32()
                MInt32.setValue(this.page_item_init)
                let protoBytes = MInt32.serializeBinary()
                let protoBytesArray = Array.from(protoBytes)
                let page_scene_8_8 = {
                    packageId: 0,
                    senderId: PAGE,
                    senderName: PAGE_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 8,
                    messageId: 8,
                    protoBytesType: 'proto.com.proto.s.MInt32',
                    protoBytes: protoBytesArray
                }
                // 发送消息
                Protocol.sender(platform, page_scene_8_8)
            }

        },

        mounted ()
        {
            console.log('aaaaa ---- 0')
            let  platform = this.$route.query.platform
            let _this = this

            // 请求动画总时长
            let page_scene_8_11 = {
                packageId: 0,
                senderId: PAGE,
                senderName: PAGE_NAME,
                receiverId: SCENE,
                receiverName: SCENE_NAME,
                timeFlag: new Date().getTime(),
                sessionId: 8,
                messageId: 11,
                protoBytesType: '',
                protoBytes: []
            }
            // 发送消息
            Protocol.sender(platform, page_scene_8_11)

            // 模块初始化
            Protocol.onSocketInit(platform, PAGE_NAME, PAGE)
            // 模块与服务器建立链接
            Protocol.onSocketConnect(platform, PAGE_NAME)
            // 模块与服务器建立链接
            Protocol.onSocketRegister(platform, PAGE_NAME, PAGE)
            window[PAGE_NAME].domReady = () => {
                // 请求同步页数据
                let page_scene_8_1 = {
                    packageId: 0,
                    senderId: PAGE,
                    senderName: PAGE_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 8,
                    messageId: 1,
                    protoBytesType: '',
                    protoBytes: []
                }
                // 发送消息
                Protocol.sender(platform, page_scene_8_1)
                
            }
            // 接收消息
            Protocol.receiver(platform, PAGE_NAME)
            window[PAGE_NAME].message = (senderId, packageId, sessionId, messageId, protoBytes) => {
                // 场景加载完成
                if (sessionId == 6 && messageId == 5) {
                    // 请求同步页数据
                    let page_scene_8_1 = {
                        packageId: 0,
                        senderId: PAGE,
                        senderName: PAGE_NAME,
                        receiverId: SCENE,
                        receiverName: SCENE_NAME,
                        timeFlag: new Date().getTime(),
                        sessionId: 8,
                        messageId: 1,
                        protoBytesType: '',
                        protoBytes: []
                    }
                    // 发送消息
                    Protocol.sender(platform, page_scene_8_1)
                }else if(sessionId == 8 && messageId == 2) { // 同步页数据
                    let pageList = Protocol.deserializeBinary('proto.com.proto.page.MPageList', protoBytes).toObject();
                    console.log("pageList:", pageList)
                    _this.total_time = 0
                    _this.page_list = []
                    for(var i=0;i<pageList.pagesList.length;i++){
                        let cover = pageList.pagesList[i].cover != '' ? "data:image/jpg;base64,"+pageList.pagesList[i].cover : '';
                        _this.page_list.push({
                            'id': 'page_' + i,
                            'active':false,
                            'cover':cover
                        })
                        // if(pageList.pagesList[i].duration){
                        //     _this.total_time += pageList.pagesList[i].duration
                        // }
                    }
                    // console.log("pageList_list:", _this.page_list)
                    let init_index = pageList.selected;
                    if(!init_index){
                        init_index = 0
                    }
                    _this.page_item_init = init_index
                    for(var i=0;i<_this.page_list.length;i++){
                        _this.page_list[i].active = false
                    }
                    _this.page_list[init_index].active = true
                }else if(sessionId == 8 && messageId == 3) { // 同步当前页索引
                    let init_index = Protocol.deserializeBinary('proto.com.proto.s.MInt32', protoBytes).array[0]
                    if(!init_index || init_index == undefined){
                        init_index = 0
                    }
                    _this.page_item_init = init_index
                    for(var i=0;i<_this.page_list.length;i++){
                        _this.page_list[i].active = false
                    }
                    if(_this.page_list.length > 0){
                        _this.page_list[init_index].active = true
                    }
                    // let bottom = document.getElementById('bottom')//.scrollIntoView({behavior: "auto", block: "center", inline: "nearest"})
                    // window.scrollTo(0,200);
                    // console.log('bbbbbbbb   ===> ')
                }else if(sessionId == 6 && messageId == 29){ // 场景开始播放

                }else if(sessionId == 6 && messageId == 30){ // 场景播放停止
                    if(_this.play_status){
                        let init_data = Protocol.deserializeBinary('proto.com.proto.editortimeline.MStepIndex', protoBytes).array
                        let init_index = init_data[1]
                        if(!init_index){
                            init_index = 0
                        }
                        _this.page_item_init = init_index
                        for(var i=0;i<_this.page_list.length;i++){
                            _this.page_list[i].active = false
                        }
                        _this.page_list[init_index].active = true
                    }else{
                        _this.play_status = true
                    }
                }else if(sessionId == 1 && messageId == 12){ // changeTab
                    _this.total_time = '00:00'
                    _this.page_list = []
                }else if(sessionId == 8 && messageId == 12){ // 动画时长
                    let playTime = Protocol.deserializeBinary('proto.com.proto.editortimeline.MPlayTime', protoBytes).toObject();
                    // console.log('aaaaa ----   ' + JSON.stringify(playTime.current) + ' === '+playTime.total + 'xxx = ' + _this.formatDuration(playTime.current))
                    _this.current_time = !playTime.current?0:playTime.current
                    _this.total_time = !playTime.total?0:playTime.total
                }
            }
        }
    }
</script>
<style scoped lang="stylus">
    .page {
        background:#5a5a5a//#e8e8e8
        position: absolute
        top: 0px
        right: 0
        bottom: 0
        left: 0
        overflow: hidden
        .total-time {
            text-align center
            height 32px
            line-height 32px
            background #303030//#cacaca
            color:#e2e2e2
            border: 1px solid #101010
        }
        .ope-list {
            overflow hidden
            height 32px
            line-height 32px
            background:#3d3d3d
            div {
                float left
                width 25%
                text-align center
                height 32px
                line-height 32px
                cursor pointer
                background #3d3d3d//#dbdbdb
                font-size 16px
                color:#fff//#545454
                &:hover {
                    background #494949//#e1e1e1
                }
                &:active {
                    background #232323//#ccc
                }
            }
        }
        .page-list {
            overflow auto
            position absolute
            top 68px
            right 0
            bottom 78px
            box-sizing border-box
            width 100%
            // background:#5a5a5a
            .page-item {
                div {
                    height 44px
                    cursor pointer
                    width 76px
                    margin 16px auto
                    position relative
                    transform scale(1)
                    transition-duration 0.5s
                    background #fff
                    border-radius 4px
                    img {
                        width 100%
                        height 100%
                    }
                    span {
                        height 44px
                        width 100%
                        display block
                        line-height 44px
                        text-align center
                        font-weight 300
                        font-size 14px
                    }
                }
                .active {
                    transform scale(1.27)
                    transition-duration 0.25s
                    border 1px solid #ff4f52
                }
            }
        }
        .play-btn {
            position absolute
            left 0
            bottom 0
            text-align center
            width 100%
            line-height 78px
            height 78px
            font-weight bold
            cursor pointer
            background #303030//#dbdbdb 
            button {
                margin-top: 10px
                width:50px
                height:30px
            }
            .icon {
                font-size: 32px
            }
            .start{
                background: url(./start_normal.png) no-repeat 50% 50%
                &:hover{
                   background: url(./start_hover.png) no-repeat 50% 50% 
                } 
                &:active{
                   background: url(./start_click.png) no-repeat 50% 50%
                } 
            }
            .stop{
                background: url(./stop_normal.png) no-repeat 50% 50%
                &:hover{
                   background: url(./stop_hover.png) no-repeat 50% 50% 
                } 
                &:active{
                   background: url(./stop_click.png) no-repeat 50% 50%
                } 
            }
              
        }
    }
</style>



// WEBPACK FOOTER //
// Page.vue?b2fad002